// https://github.com/Automattic/woocommerce-services/pull/635
// https://github.com/babel/babel/issues/1943
if ( ! global._babelPolyfill ) {
	require( 'babel-polyfill' );
}

import React from 'react'
import { render } from 'react-dom'
// import { Provider } from 'react-redux'
// import { createStore } from 'redux'
// import stylistApp from './editor/reducers'

import App from './editor/app/';
import Header from './editor/header/';
import Sidebar from './editor/sidebar/';


/* Import CSS */
import './index.scss'

/* Import plugins and 3-rd party libraries */

// import './get-default-value.js'
// import './globals'


// Document ready.
// document.addEventListener( 'DOMContentLoaded', function() {
document.addEventListener( 'readyToStart', function() {
	// Frame ready.
	render(
		<App />,
		document.getElementById( 'stylist-root' )
	)
} );



// WEBPACK FOOTER //
// ./dev/stylist_parent/index.js